// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"CredentialError_modalContainer__R5wca","headerText":"CredentialError_headerText__2zkWq","headerError":"CredentialError_headerError__2LPQD"};